import React from "react";

export class Error extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      return (
        <>
          <h1>Ha ocurrido un error</h1>
          {console.log(this.props)}
        </>
      );
    }
    return this.props.children;
  }
}
